import cn from 'classnames'

import SearchIcon from './icons/search.svg'
import SearchBtnIcon from './icons/search-btn.svg'

import styles from './styles.module.scss'
import { SearchProps } from './search.props'
import { useTranslation } from 'utils/use-translation'

export default function Search({
  className,
  onChange,
  value,
  placeholder,
  isWithButton,
  onBtnSearchClick,
  isSearchDisabled,
}: SearchProps) {
  const { t } = useTranslation()
  
  const handleInputChange = (e) => {
    const value = e.target.value
    onChange(value)
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      onBtnSearchClick()
    }
  }

  return (
    <div className={cn(styles.search, className)}>
      {!isWithButton && <img src={SearchIcon} className={styles.searchIcon} alt="icon search arrow" />}
      <input
        value={value ?? ''}
        className={styles.listSearchInput}
        type="text"
        placeholder={placeholder ?? t('search')}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      {isWithButton && (
        <button disabled={isSearchDisabled} onClick={onBtnSearchClick} className={styles.btnSearch}>
          <img src={SearchBtnIcon} alt="search btn icon" />
        </button>
      )}
    </div>
  )
}
